export enum DATA_QA {
  ROOT = 'csv-import-details-step',
  ROW_COUNT = 'csv-import-details-step__row-count',
  BACK = 'csv-import-details-step__back',
  NEXT = 'csv-import-details-step__next',
}
